module.exports = __webpack_public_path__ + "static/media/book-bank.fc71303f.png";